import { CANVAS_SLIDE_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { ISlideEditorProps, SlideEditor } from './index';

export class MasterEditor extends SlideEditor {
    public constructor(props: ISlideEditorProps) {
        super(props);

        const { slide } = props;
        this.canvasDom.id = `master-${CANVAS_SLIDE_ID_PREFIX}-${slide.key}`;
    }

    protected buildMasterLayoutByCache(): void {}
    protected reloadMasterComponent(): void {}
    protected reloadLayoutComponent(): void {}
}
